import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getAccessBuildingsService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values)
        const response = await customFetch(`${API_URL}accessBuildings`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}